import React, { Component, useState } from "react";
import * as Yup from "yup";
import { useAlert } from "../context/AlertContext";
import { useLoading } from "context/LoadingContext";
import { forgotPassApi } from "../Service/ApiService";
import { useNavigate } from "react-router-dom";

// Define validation schema
const schema = Yup.object().shape({
  vendorCode: Yup.string()
    .required("Vendor code is required")
    .matches(/^\d+$/, "Vendor code must contain only numbers")
    .min(6, "Vendor code must be atleast 6 characters"),
  mobile: Yup.string()
    .required("Mobile Number is required")
    .length(10, "Enter valid mobile number."),
});

const ForgotPasswordController = () => {
  const [vendorCode, setVendorCode] = useState();
  const [mobile, setMobile] = useState();
  const [errors, setErrors] = useState({});
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();

  const navigate = useNavigate();

  // Validate individual field on change
  const validateField = async (fieldName, value) => {
    try {
      await Yup.reach(schema, fieldName).validate(value);
      setErrors((prev) => ({ ...prev, [fieldName]: null }));
    } catch (err) {
      setErrors((prev) => ({ ...prev, [fieldName]: err.message }));
    }
  };

  // Set User code
  const handleVendorCodeChange = (e) => {
    setVendorCode(e.target.value);

    validateField("vendorCode", e.target.value);
  };

  // Set password
  const handleMobileChange = (e) => {
    setMobile(e.target.value);

    validateField("mobile", e.target.value);
  };

  // Form submit
  const handleSubmit = async (e) => {
    try {
      console.log(1);
      await schema.validate({ vendorCode, mobile }, { abortEarly: false });

      setLoading(true);

      const response = await forgotPassApi(vendorCode, mobile);
      if (response.success) {
        showAlert(response.msg, {
          icon: "success",
          title: "Success",
        });
        setLoading(false);

        navigate("/otpverify", {
          state: {
            mobile: response.data.mobileNo,
            vendorCode: response.data.vendorId,
            vendorCode: response.data.vendorCode,
            your_otp: response.data.otp,
          },
        });
      } else {
        showAlert(response.msg);
        setLoading(false);
      }
    } catch (error) {
      showAlert("Please fill valid inputs!");
      setLoading(false);
    }
  };

  return {
    vendorCode,
    mobile,
    errors,
    handleVendorCodeChange,
    handleMobileChange,
    handleSubmit,
  };
};

export default ForgotPasswordController;
